import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
import CheckGreen from './../images/check-green.svg';

const Container = styled.aside`
  text-align: center;
`;

const TitleBox = styled.div`
  @media (min-width: 1000px) {
    color: #4a4a4a;
    line-height: 1.31;
    display: inline-block;
  }

  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

const Title = styled.h1`
  font-size: 1.3em;
  margin: 0px 16px;
  font-weight: 700;
  color: #4A4A4A;

  @media (min-width: 1000px) {
    font-size: 36px;
    display: inline-block;
    vertical-align: middle;
  }
`;

const Image = styled.img`
  display: none;

  @media (min-width: 1000px) {
    display: inline;
    vertical-align: middle;
  }
`;

const ProductsTitle = ({ title, type }) => (
  <Container data-e2e="product-title-container">
    <TitleBox data-e2e="title-box">
      {['free-insertion', 'free-edition'].indexOf(type) !== -1
        && <Image data-e2e="check" src={CheckGreen} alt="Logo OLX" />}
      <Title>{title}</Title>
    </TitleBox>
  </Container>
);

ProductsTitle.propTypes = {
  title: string.isRequired,
  type: string.isRequired,
};

export default ProductsTitle;
